import { createMessage } from '@formkit/core';
import { dateStringToDate } from './data-transforms';
import { calculateAge } from './common-helper';

/**
 * Sets an input state validity depending on if validationMessage is empty or not
 *
 * @param validationMessage The validation message to show or empty string
 */
// Set/clear a custom error on a single input
export function setFormkitInputValidationMessage(inputRef: any, validationMessage?: string, commit?: boolean) {
  const node = inputRef?.node;
  if (!node) return;

  if (validationMessage) {
    // 1) add a blocking validation message (this drives data-invalid)
    node.store.set(
      createMessage({
        key: 'custom', // any unique key is fine
        type: 'validation', // must be 'validation'
        value: validationMessage,
        blocking: true, // must be true to set data-invalid
      })
    );

    // 2) set UI flags many themes rely on (for red styles)
    node.store.set(createMessage({ key: 'failing', value: true, visible: false }));
    node.store.set(createMessage({ key: 'submitted', type: 'ui', value: true, visible: false }));
    node.store.set(createMessage({ key: 'touched', type: 'ui', value: true, visible: false }));

    if (commit) {
      // 3) force recompute of attributes
      node.emit('commit');
    }
  } else {
    // clear all validation messages
    node.store.filter(() => false, 'validation');
    // clear any custom failing flag you might have used earlier
    node.store.remove('failing', 'ui');
    // mark as not submitted (optional)
    node.store.set(createMessage({ key: 'submitted', type: 'ui', value: false, visible: false }));
    if (commit) {
      node.emit('commit');
    }
  }
}

export function dayMonthNotInFuture(node: any, monthField: string, yearField: string) {
  const parent = node.at('$parent');
  const monthValue = parent?.value?.[monthField];
  const yearValue = parent?.value?.[yearField];

  if (!monthValue || !yearValue) return true; // Skip validation if either field is missing

  const selectedDate = new Date(yearValue, monthValue - 1); // Month is 0-indexed
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const isValid = selectedDate <= today;

  if (!isValid) {
    parent?.node?.store?.set(monthField, { validation: 'dayMonthNotInFuture' });
    parent?.node?.store?.set(yearField, { validation: 'dayMonthNotInFuture' });
  }

  return isValid;
}

export function dateOfBirthIsValid(dateOfBirth: string, minAge: number | undefined) {
  if (!dateOfBirth) return false;
  const date = dateStringToDate(dateOfBirth, 'dd/MM/yyyy');
  const result = calculateAge(date) < Number(minAge ?? 16);
  return !result;
}
